// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CoffeeOutlinedSvg from "@ant-design/icons-svg/es/asn/CoffeeOutlined";
import AntdIcon from '../components/AntdIcon';

var CoffeeOutlined = function CoffeeOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CoffeeOutlinedSvg
  }));
};

CoffeeOutlined.displayName = 'CoffeeOutlined';
export default React.forwardRef(CoffeeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CoffeeOutlined.js
// module id = 833
// module chunks = 0